var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-circle',{attrs:{"r":_vm.r,"selectable":_vm.selectable,"disabled":_vm.disabled},on:{"choose":function($event){return _vm.$emit('choose')}}})}
var staticRenderFns = []

export { render, staticRenderFns }